import axios from 'axios';
import { API } from '../../../config/api';
import { basicAuth } from '../../../config/auth';

export const FETCH_USER_DETAILS_REQUEST = 'FETCH_USER_DETAILS_REQUEST';
export const FETCH_USER_DETAILS_SUCCESS = 'FETCH_USER_DETAILS_SUCCESS';
export const FETCH_USER_DETAILS_FAILURE = 'FETCH_USER_DETAILS_FAILURE';

export const fetchUserDetailsRequest = () => ({ type: FETCH_USER_DETAILS_REQUEST });
export const fetchUserDetailsSuccess = (data) => ({ type: FETCH_USER_DETAILS_SUCCESS, payload: data });
export const fetchUserDetailsFailure = (error) => ({ type: FETCH_USER_DETAILS_FAILURE, payload: error });

export const fetchUserDetails = (userId) => {
  return async (dispatch) => {
    dispatch(fetchUserDetailsRequest());
    try {
      const response = await axios.get(`${API.auth.user}/${userId}`, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Basic ${basicAuth}`,
        },
      });

      dispatch(fetchUserDetailsSuccess(response.data.user));
    } catch (error) {
      console.error('Error fetching user details:', error);
      dispatch(fetchUserDetailsFailure(error.message));
    }
  };
};
